<template>
    <el-card style="position: relative">
        <div slot="header" class="clearfix">
            <div class="left">
                <span @click="goBack" style="cursor:pointer">
                    <span class="top_title">订单列表</span>
                </span>
                <span>
                    <i class="iconfont">&#xe605;</i>
                    <span class="top_title">订单详情</span>
                </span>
            </div>
        </div>
        <div class="number_box">
            订单编号:{{ orderForm.number }}
        </div>
        <el-steps :active="checkSteps" align-center v-show="searchType==1" finish-status="success" style="margin-bottom:10px">
            <el-step title="订单审核"></el-step>
            <el-step title="审核通过"></el-step>
            <el-step title="订单发货中"></el-step>
            <el-step title="订单完成"></el-step>
        </el-steps>
        <div class="searchItem">
            <div class="search">
                <span class="searchtips" style="font-size: 18px;color: #f33333;">{{
                orderStatus[orderForm.state]}}</span>
            </div>
            <div class="search">
                <span class="searchtips">客户:{{orderForm.cname}}</span>
            </div>
            <div class="search">
                <span class="searchtips">销售员:{{orderForm.empName}}</span>
            </div>
            <div class="search">
                <span class="searchtips">是否已结算:{{orderForm.payed?'已结算':'未结算'}}</span>
            </div>
            <div class="search">
                <span class="searchtips">已免除:{{orderForm.freeSum}}元</span>
            </div>
            <div class="search">
                <span class="searchtips">已收款:{{orderForm.paySum}}元</span>
            </div>
            <div class="search">
                <span class="searchtips">订货日期: {{ orderForm.date }}</span>
            </div>
            <div class="search">
                <span class="searchtips">交货日期:{{orderForm.expect?orderForm.expect:'无'}}</span>
            </div>
            <div class="search">
                <el-button
                    type="primary"
                    icon="el-icon-printer"
                    @click="print"
                    v-if="$common.checkWindowsEnv()"
                    >打印</el-button>
                <el-button
                    type="primary"
                    icon="el-icon-document"
                    @click="changePdf"
                >导出</el-button>
            </div>
        </div>
            <el-form
                :inline="true"
                :model="orderForm"
                label-width="100px"
                style="height: 76vh; overflow: auto"
            >
                <el-table
                    ref="multipleTable"
                    v-loading="listLoading"
                    :data="orderForm.detail"
                    border
                    fit
                    highlight-current-row
                    show-summary
                    :summary-method="getSummaries"
                    :max-height="437"
                    style="width: 100%"
                    :header-cell-style="{ 'background-color': '#F5F7FA' }"
                    @row-click="checkThis"
                    @cell-click="editCell"
                >
                    <el-table-column align="center" width="120" v-if="orderForm.state===0">
                        <template #header>
                            <span style="padding-right:4px">操作</span>
                            <el-button
                                size="mini"
                                icon="el-icon-plus"
                                circle
                                @click="addRow()"
                            />
                        </template>
                        <template slot-scope="scope">
                            <el-button
                                v-if="scope.row.id>0"
                                size="mini"
                                icon="el-icon-document-copy"
                                circle
                                @click.stop="addSameRow(scope.row,scope.$index)"
                            />
                            <el-button
                                v-if="!scope.row.id"
                                size="mini"
                                icon="el-icon-minus"
                                type="danger"
                                circle
                                @click.stop="removeRow(scope.$index, scope.row)"
                            />
                            <el-button
                                v-else-if="
                                    scope.row.valid === 1 &&
                                    scope.row.id > 0
                                "
                                size="mini"
                                icon="el-icon-delete"
                                type="danger"
                                circle
                                title="禁用"
                                @click.stop="changeValid(0, scope.row)"
                            />
                            <el-button
                                v-else-if="
                                    scope.row.valid !== 1 &&
                                    scope.row.id > 0
                                "
                                size="mini"
                                icon="el-icon-document-checked"
                                circle
                                title="启用"
                                @click.stop="changeValid(1, scope.row)"
                            />
                        </template>
                    </el-table-column>

                    <template v-for="(col, index) in cols">
                        <el-table-column
                            v-if="col.show"
                            :key="index"
                            :label="col.label"
                            :width="col.width"
                            :align="col.align"
                            :min-width="col.min_width"
                            :class-name="col.class"
                        >
                            <template slot-scope="{ row, column }">
                                <template v-if="col.edit">
                                    <template
                                        v-if="col.type === 'selectEdit'"
                                    >
                                        <template
                                            v-if="
                                                row[col.edit] &&
                                                row.valid &&
                                                orderForm.state === 0&&(!row.id)
                                            "
                                        >
                                            <el-select
                                                ref="editCell"
                                                v-model="row[col.prop]"
                                                placeholder="请输入商品编号或商品名称"
                                                filterable
                                                remote
                                                :remote-method="getProduct"
                                                value-key="id"
                                                style="width: 100%"
                                                @visible-change="
                                                    $forceUpdate()
                                                "
                                                @click.native.stop="
                                                    cancelCell(row)
                                                "
                                                @change="
                                                    chooseSpecs(
                                                        $event,
                                                        row,
                                                        column
                                                    )
                                                "
                                                @keyup.enter.native="
                                                    cancel(row, column)
                                                "
                                                @blur="getData(row, column)"
                                            >
                                                <el-row
                                                    style="
                                                        width: 600px;
                                                        height: 40px;
                                                        line-height: 40px;
                                                        background: #d6d7d9;
                                                    "
                                                >
                                                    <el-col
                                                        :span="5"
                                                        :offset="2"
                                                        style="
                                                            font-size: 14px;
                                                            text-align: center;
                                                        "
                                                        >商品编号</el-col
                                                    >
                                                    <el-col
                                                        :span="9"
                                                        style="
                                                            font-size: 14px;
                                                            text-align: center;
                                                        "
                                                        >商品名称</el-col
                                                    >
                                                    <el-col
                                                        :span="3"
                                                        style="
                                                            font-size: 14px;
                                                            text-align: center;
                                                        "
                                                        >颜色</el-col
                                                    >
                                                    <el-col
                                                        :span="3"
                                                        style="
                                                            font-size: 14px;
                                                            text-align: center;
                                                        "
                                                        >尺码</el-col
                                                    >
                                                </el-row>
                                                <el-option
                                                    v-for="(
                                                        item, index1
                                                    ) in productList"
                                                    :key="index1"
                                                    :label="
                                                        item.number +
                                                        ' ' +
                                                        item.name +
                                                        (item.color !== ''
                                                            ? '_' +
                                                                item.color
                                                            : '') +
                                                        (item.size !== ''
                                                            ? '_' +
                                                                item.size
                                                            : '')
                                                    "
                                                    :value="item"
                                                    style="
                                                        width: 600px;
                                                        height: 40px;
                                                        padding: 0;
                                                    "
                                                >
                                                    <el-row
                                                        style="
                                                            width: 600px;
                                                            height: 40px;
                                                            line-height: 40px;
                                                        "
                                                    >
                                                        <el-col
                                                            :span="5"
                                                            :offset="2"
                                                            style="
                                                                font-size: 14px;
                                                                text-align: center;
                                                            "
                                                        >
                                                            {{
                                                                item.number
                                                            }}
                                                        </el-col>
                                                        <el-col
                                                            :span="9"
                                                            style="
                                                                font-size: 14px;
                                                                text-align: center;
                                                            "
                                                        >
                                                            {{ item.name }}
                                                        </el-col>
                                                        <el-col
                                                            :span="3"
                                                            style="
                                                                font-size: 14px;
                                                                text-align: center;
                                                            "
                                                        >
                                                            {{ item.color }}
                                                        </el-col>
                                                        <el-col
                                                            :span="3"
                                                            style="
                                                                font-size: 14px;
                                                                text-align: center;
                                                            "
                                                        >
                                                            {{ item.size }}
                                                        </el-col>
                                                    </el-row>
                                                </el-option>
                                            </el-select>
                                            <span
                                                class="productList"
                                                @click="productMany(row)"
                                                ><i class="el-icon-more"
                                            /></span>
                                        </template>
                                        <span v-else>{{
                                            row[col.prop]
                                        }}</span>
                                    </template>
            <template v-else-if="col.edit === 'smallEdit'">
                <el-input
                    v-if="row[col.edit]&&row.valid &&orderForm.state === 0"
                    ref="editCell"
                    type="number"
                    v-model="row[col.prop]"
                    @click.native.stop="cancelCell(row)"
                    @blur="cancel(row, column)"
                    @keyup.enter.native="
                        cancel(row, column)
                    "
                    :min="0"
                    @change="changeNumSum($event,row,col.prop)"
                />
                <span v-else>{{ row[col.prop] }}</span>
            </template>
            <template v-else-if="col.edit === 'countEdit'">
                <el-input
                    v-if="row[col.edit]&&row.valid &&orderForm.state === 0"
                    ref="editCell"
                    type="number"
                    v-model="row[col.prop]"
                    @click.native.stop="cancelCell(row)"
                    @blur="cancel(row, column)"
                    @keyup.enter.native="
                        cancel(row, column)
                    "
                    :min="0"
                    @change="changeNumSum($event,row,col.prop)"
                />
                <div v-else>
                    <span >{{ row[col.prop] }}</span>
                </div>
                
                </template>
                                    <template
                                        v-else-if="col.type === 'input'"
                                    >
                                        <el-input
                                            v-if="
                                                row[col.edit] &&
                                                row.valid &&
                                                orderForm.state === 0
                                            "
                                            ref="editCell"
                                            v-model="row[col.prop]"
                                            @click.native.stop="
                                                cancelCell(row)
                                            "
                                            @blur="cancel(row, column)"
                                            @keyup.enter.native="
                                                cancel(row, column)
                                            "
                                            @change="checkTableNumber($event,row)"
                                        />
                                        <span v-else>{{
                                            row[col.prop]
                                        }}</span>
                                    </template>
                                    <template
                                        v-else-if="col.type === 'icon'"
                                    >
                                        <el-input
                                            v-if="
                                                row[col.edit] &&
                                                row.valid &&
                                                orderForm.state === 0
                                            "
                                            ref="editCell"
                                            v-model="row[col.prop]"
                                            maxlength="20"
                                            @click.native.stop="
                                                cancelCell(row)
                                            "
                                            @blur="cancel(row, column)"
                                            @keyup.enter.native="
                                                cancel(row, column)
                                            "
                                            @change="changeSum(row)"
                                        />
                                        <span v-else-if="row[col.prop]">{{
                                            row[col.prop]
                                        }}</span>
                                        <div v-else>
                                            <i
                                                class="el-icon-edit-outline"
                                            />
                                        </div>
                                    </template>
                                </template>
                                <template v-else>
                                    <template
                                        v-if="
                                            col.type.substring(
                                                0,
                                                'sum.'.length
                                            ) === 'sum.'
                                        "
                                    >
                                        <el-input
                                            v-model="row[col.prop]"
                                            type="hidden"
                                            :value="sum(row)"
                                            readonly
                                            style="display: none"
                                        />
                                        <span>{{ row[col.prop] }}</span>
                                    </template>
                                    <template
                                        v-else-if="
                                            col.type.substring(
                                                0,
                                                'sumPrice.'.length
                                            ) === 'sumPrice.'
                                        "
                                    >
                                        <el-input
                                            v-model="row[col.prop]"
                                            type="hidden"
                                            :value="sumPrice(row)"
                                            readonly
                                            style="display: none"
                                        />
                                        <span>{{ row[col.prop] }}</span>
                                    </template>
                                    <template
                                        v-else-if="col.type === 'image'"
                                    >
                                        <el-image
                                            v-if="
                                                row[col.prop] &&
                                                row[col.prop].length > 0
                                            "
                                            style="width: 30px"
                                            :src="row[col.prop][0]"
                                            :preview-src-list="
                                                row[col.prop]
                                            "
                                        >
                                        <template #error>
                                            <div class="errorFonts_mini">暂无图片</div>
                                        </template>
                                        </el-image>
                                        <div v-else class="errorFonts_mini">暂无图片</div>
                                    </template>
                                    <template
                                        v-else-if="col.type === 'send'"
                                    >
                                        <span
                                            v-if="
                                                row.unit === row.sended
                                            "
                                            >已发货</span
                                        >
                                        <span
                                            v-else-if="row.sended == 0||row.sended == null"
                                            >未发货</span
                                        >
                                        <span v-else
                                            >已发{{ row[col.prop] }}</span
                                        >
                                    </template>
                                    <template v-else>{{
                                        row[col.prop]
                                    }}</template>
                                </template>
                            </template>
                        </el-table-column>
                    </template>
                </el-table>
                <div class="searchItem" style="margin-top:20px" v-if="orderForm.state==0">
                    <div class="search">
                        <span class="searchtips">发票类型:</span>
                        <el-select
                            ref="invoiceCheck"
                            v-model="orderForm.invoicetype"
                            :value="orderForm.invoicetype"
                            placeholder="请选择"
                            :disabled="!orderForm.cid"
                            @change="invoiceChange"
                            style="width:150px;margin-right:10px"
                        >
                            <el-option
                                v-for="item in invoiceTypes"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                    </div>
                    <div class="search">
                        <span class="searchtips">结算账号</span>
                        <el-select
                            v-model="orderForm.accountid"
                            placeholder=""
                            value-key="id"
                            default-first-option
                            popper-class="select-option"
                            style="width:180px"
                            @visible-change="$forceUpdate()"
                            @change="setAccount"
                        >
                            <el-option
                                v-for="(item, index) in acList"
                                :key="index"
                                :value="item.id"
                                :label="item.name + '-' + item.account"
                                style="height: 40px; line-height: 40px"
                            />
                        </el-select>
                        <span
                            style="position: relative;right: 25px;background: #fff;cursor: pointer;"
                            @click="accountListDialog = true"
                            ><i class="el-icon-more"
                        /></span>
                    </div>
                    <div class="search" v-if="$global.useinstall==1">
                        <span class="searchtips">货运方式:</span>
                        <el-select v-model="orderForm.method" style="width:180px">
                            <el-option value="自提" label="自提"></el-option>
                            <el-option value="车辆运送" label="车辆运送"></el-option>
                            <el-option value="物流" label="物流"></el-option>
                        </el-select>
                    </div>
                    <div class="search">
                        <span class="searchtips" style="line-height:60px">备注</span>
                        <el-input
                            v-model="orderForm.remark"
                            type="textarea"
                            maxlength="100"
                            class="tastyle"
                            style="width: 514px"
                            @visible-change="$forceUpdate()"
                        />
                    </div>
                </div>
                <div v-else>
                    <div class="search">
                        <span class="searchtips" style="padding-right:0px">发票类型:</span>
                        <span v-if="orderForm.invoicetype==0">不开发票</span>
                        <span v-else-if="orderForm.invoicetype==1">增值税普通发票</span>
                        <span v-else-if="orderForm.invoicetype==2">增值税专用发票</span>
                    </div>
                    <div class="search">
                        <span class="searchtips">结算账号:{{orderForm.accountname}}</span>
                    </div>
                    <div class="search" v-if="$global.useinstall==1">
                        <span class="searchtips">货运方式:{{orderForm.method}}</span>
                    </div>
                    <div class="search">
                        <span class="searchtips">备注:{{orderForm.remark}}</span>
                    </div>
                </div>
                <div>
                    <div v-if="$global.useinstall==1&&orderForm.state==0">
                        <span class="searchtips">安装地址</span>
                        <el-input maxlength="200" style="width:480px" v-model="orderForm.address"></el-input>
                    </div>
                    <div v-else-if="$global.useinstall==1&&orderForm.state!=0">
                        <span class="searchtips">安装地址:{{orderForm.district+orderForm.address}}</span>
                    </div>
                    <div v-if="orderForm.state==0">
                        <Address ref='paddr' @setContact='setContact' :cid='orderForm.cid' :contact='orderForm.contact'></Address>
                    </div>
                    <div v-else>

                    </div>
                    <div v-show="orderForm.invoicetype>0">
                        <span class="searchtips">发票信息</span>
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="invoiceDialog = true"
                            v-if="orderForm.state==0"
                        />
                        <span
                            v-if="orderForm.invoicetype === 1"
                            class="el-upload__tip"
                            >发票抬头：{{
                                orderForm.invoice
                            }}，纳税人识别号：{{
                                orderForm.taxidentification
                            }}</span
                        >
                        <span
                            v-if="orderForm.invoicetype === 2"
                            class="el-upload__tip"
                            >发票抬头：{{
                                orderForm.invoice
                            }}，纳税人识别号：{{
                                orderForm.taxidentification
                            }}， 地址:{{
                                orderForm.invoiceaddress
                            }}，电话：{{
                                orderForm.invoicephone
                            }}，开户银行：{{
                                orderForm.bankname
                            }}，银行账号：{{
                                orderForm.bankaccountnumber
                            }}</span
                        >
                    </div>
                </div>
                <div style="padding-bottom: 22px"></div>
                <el-form-item
                    style="
                        background-color: #ffffff;
                        width: 100%;
                        text-align: center;
                        padding: 10px 0;
                    "
                >
                    <el-button
                        v-if="orderForm.state === 0"
                        type="primary"
                        @click="editSure"
                        >保存</el-button
                    >
                </el-form-item>
            </el-form>
        <template>
            <el-dialog :visible.sync="accountListDialog" title="结算账号列表"  width="60%">
                <account-list
                    ref="accountList"
                    @close="closeAccount(arguments)"
                />
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="accountSelected"
                        >确认</el-button
                    >
                    <el-button @click="accountListDialog = false"
                        >取消</el-button
                    >
                </div>
            </el-dialog>
            <el-dialog :visible.sync="invoiceDialog" title="发票信息更改/补充" width="60%">
                <el-form
                    ref="invoiceform"
                    :inline="true"
                    :model="invoiceform"
                    :rules="invoicerules"
                >
                    <el-form-item
                        label="发票抬头"
                        prop="invoice"
                        :label-width="formLabelWidth"
                    >
                        <el-input
                            v-model="invoiceform.invoice"
                            maxlength="100"
                            style="width: 240px"
                        />
                    </el-form-item>
                    <el-form-item
                        label="纳税人识别号"
                        prop="taxIdentification"
                        :label-width="formLabelWidth"
                    >
                        <el-input
                            v-model="invoiceform.taxIdentification"
                            maxlength="50"
                            style="width: 240px"
                        />
                    </el-form-item>
                    <el-form-item
                        v-if="orderForm.invoicetype === 2"
                        label="地址"
                        :label-width="formLabelWidth"
                        prop="invoiceaddress"
                    >
                        <el-input
                            v-model="invoiceform.invoiceaddress"
                            maxlength="80"
                            style="width: 240px"
                        />
                    </el-form-item>
                    <el-form-item
                        v-if="orderForm.invoicetype === 2"
                        label="电话"
                        :label-width="formLabelWidth"
                        prop="invoicephone"
                    >
                        <el-input
                            v-model="invoiceform.invoicephone"
                            maxlength="20"
                            style="width: 240px"
                        />
                    </el-form-item>
                    <el-form-item
                        v-if="orderForm.invoicetype === 2"
                        label="开户银行"
                        :label-width="formLabelWidth"
                        prop="bankname"
                    >
                        <el-input
                            v-model="invoiceform.bankname"
                            maxlength="50"
                            style="width: 240px"
                        />
                    </el-form-item>
                    <el-form-item
                        v-if="orderForm.invoicetype === 2"
                        label="银行账号"
                        :label-width="formLabelWidth"
                        prop="bankaccountnumber"
                    >
                        <el-input
                            v-model="invoiceform.bankaccountnumber"
                            maxlength="50"
                            style="width: 240px"
                        />
                    </el-form-item>
                    <el-form-item
                        style="
                            display: block;
                            text-align: center;
                            padding-top: 20px;
                        "
                    >
                        <el-button type="primary" @click="saveInvoice"
                            >确认</el-button
                        >
                        <el-button @click="cancelInvoice">取消</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
            <el-dialog
                :visible.sync="productListDialog"
                title="商品列表"
                width="90%"
            >
                <pro-list ref="proList" :cid="orderForm.cid" @close="closeProductList(arguments)" />
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="proSelected"
                        >确认</el-button
                    >
                    <el-button @click="productListDialog = false"
                        >取消</el-button
                    >
                </div>
            </el-dialog>
            <ReportOrder ref="roder"></ReportOrder>
            <edit-share ref="share"></edit-share>
        </template>
    </el-card>
</template>

<script>
import proList from "@/components/product/list";
import accountList from "@/components/capital/list";
import Address from "../../components/place/index.vue";
import SendList from "@/components/deliver/list";
import ReportOrder from '../../components/printshare/reportorder'
import editShare from '../../components/printshare/edit_share';
import Innumber from '../../components/tool/innumber.vue';
const oStatus = {
    "-1": "已关闭",
    0: "待确认",
    1: "已确认",
    2: "待开单",
    3: "部分开单",
    4: "已开单",
    5: "已锁定",
};


export default {
    components: {
        accountList,
        proList,
        SendList,
        ReportOrder,
        Address,
        editShare,
        Innumber,
    },
    data() {
        return {
            imgProfit: this.$api.baseURL,
            orderStatus: oStatus,
            orderForm: {},
            invoiceTypes: [
                {
                    value: 0,
                    label: "不开发票",
                },
                {
                    value: 1,
                    label: "增值税普通发票",
                },
                {
                    value: 2,
                    label: "增值税专用发票",
                },
            ],
            acList: [],
            orderList: [],
            curOrder: 0,
            product: {},
            listLoading: false,
            accountListDialog: false,
            invoiceDialog: false,
            cols: [
                {
                    prop: "pnumber",
                    label: "商品编号",
                    edit: "",
                    type: "",
                    min_width: 100,
                    show: true,
                    sumUp: "",
                },
                {
                    prop: "name",
                    label: "商品名称",
                    edit: "nameEdit",
                    type: "selectEdit",
                    min_width: 200,
                    show: true,
                    sumUp: "合计",
                },
                {
                    prop: "image",
                    label: "图片",
                    edit: "",
                    type: "image",
                    width: 55,
                    align: "center",
                    show: true,
                    sumUp: "",
                },
                {
                    prop: "packing",
                    label: "包装单位",
                    edit: "",
                    type: "",
                    width: 85,
                    show: true,
                    sumUp: "",
                },
                {
                    prop: "count",
                    label: this.$global.pack+"数",
                    edit: "countEdit",
                    type: "input",
                    width: 195,
                    show: this.$global.buyType!=2?true:false,
                    sumUp: "sum.0",
                },
                {
                    prop: "small",
                    label: this.$global.unit+"数",
                    edit: "smallEdit",
                    type: "input",
                    width: 160,
                    show: this.$global.buyType!=1?true:false,
                    sumUp: "sum.0",
                },
                {
                    prop: "unit",
                    label: "总数",
                    edit: "",
                    type: "",
                    width: 120,
                    show: this.$global.buyType==0?true:false,
                    sumUp: "sum.0",
                },
                {
                    prop: "sendedDesc",
                    label: "发货状态",
                    edit: "",
                    type: "send",
                    width: 130,
                    show: true,
                    sumUp: "",
                },
                {
                    prop: "price",
                    label: "单价(元)",
                    edit: "",
                    type: "",
                    width: 80,
                    show: this.$global.showProductPrice,
                    sumUp: "",
                },
                {
                    prop: "sum",
                    label: "总价(元)",
                    edit: "",
                    type: "",
                    width: "",
                    show: this.$global.showProductPrice,
                    sumUp: "sum.2",
                },
                {
                    prop: "stockDesc",
                    label: "库存",
                    edit: "",
                    type: "",
                    min_width: 200,
                    show: this.$common.hasLimits("stockInfo"),
                    sumUp: "",
                },
                {
                    prop: "remark",
                    label: "备注",
                    edit: "remarkEdit",
                    type: "icon",
                    min_width: 200,
                    align: "center",
                    show: true,
                    sumUp: "",
                },
                {
                    prop: "udate",
                    label: "修改时间",
                    edit: "",
                    type: "",
                    width: 150,
                    show: true,
                    sumUp: "",
                },
            ],
            productList: [],
            invoiceform: {
                invoice: "",
                taxIdentification: "",
                invoiceaddress: "",
                invoicephone: "",
                bankname: "",
                bankaccountnumber: "",
            },
            invoicerules: {
                invoice: [
                    {
                        required: true,
                        message: "请输入发票抬头",
                    },
                ],
                taxIdentification: [
                    {
                        required: true,
                        message: "请输入纳税人识别号",
                    },
                ],
                invoiceaddress: [
                    {
                        required: true,
                        message: "请输入联系地址",
                    },
                ],
                invoicephone: [
                    {
                        required: true,
                        message: "请输入手机号",
                    },
                ],
                bankname: [
                    {
                        required: true,
                        message: "请输入开户银行",
                    },
                ],
                bankaccountnumber: [
                    {
                        required: true,
                        message: "请输入开户银行账号",
                    },
                ],
            },
            formLabelWidth: "120px",
            accountSelect: "",
            productListDialog: false,
            curRow: {},
            curCol: "",
            searchType:1,

        };
    },
    created() {
        this.getId();
        this.getList();
        this.getAccount();
    },
    methods: {
        print() {
            this.$nextTick(()=>{
                let arr = [];
                arr.push(this.curOrder);
                this.$refs.roder.extraOpen(0,arr);
            })
        },
        changePdf(){
            this.$nextTick(()=>{
                let arr = [];
                arr.push(this.curOrder);
                this.$refs.share.openList(arr);
            })
        },
        setContact(id){
            this.orderForm.contact = id;
        },
        proSelected() {
            this.$nextTick(() => {
                this.$refs.proList.selectProduct();
            });
        },
        getDetailIndex(key,val){
            for(let i in this.orderForm.detail){
                let obj = this.orderForm.detail[i];
                if(obj[key]==val){
                    return i;
                }
            }
        },
        closeProductList(value) {
            let index = -1;
            if(this.curRow.id>0){
                index = this.getDetailIndex('id', this.curRow.id);
            }else if(this.curRow.index>0){
                index = this.getDetailIndex('index', this.curRow.index);
            }
            let productSelect = value[0];
            let row = {};
            productSelect.forEach(e=>{
                e.specs.forEach(s=>{
                    if(s.count>0||s.num>0){
                        let totalunit = s.count*s.unit+s.num;
                        let totalp = totalunit*s.price;
                        row = {
                            pid: e.id,
                            spid: s.id,
                            packing:e.unit+this.$global.unit+'/'+this.$global.pack,
                            image:e.image.length>0?e.image:[],
                            price: s.price,
                            unitCount: s.unit,
                            count: s.count,
                            small: s.num,
                            sum: totalp?totalp.toFixed(2):'0.00',
                            remark: s.remark,
                            unit:totalunit,
                            sended:0,
                            stockDesc:this.getStockDesc(s,2),
                            id: "",
                            pnumber:e.number,
                            name:
                                e.name +
                                (s.color !==""?"_"+s.color:"")+
                                (s.size !==""?"_"+s.size:""),
                            countEdit: false,
                            nameEdit: false,
                            priceEdit: false,
                            remark: "",
                            remarkEdit: false,
                            smallEdit: false,
                            valid: 1,
                        };
                        console.log(s);
                        if (this.orderForm.detail[index].name) {
                            this.orderForm.detail.splice(index+1, 0, row);
                            index++;
                        } else {
                            this.orderForm.detail.splice(index, 1, row);
                        }
                        this.orderForm.adddetail.push(row);
                    }
                })
            })
            for(let i=0;i<this.orderForm.adddetail.length;i++){
                this.orderForm.adddetail[i].index = i+1;
            }
            this.productListDialog = false;
            this.$nextTick(()=>{
                this.$refs.proList.clearSelect();
            })
        },
        changeNumSum(e,row,type){
            let key = parseInt(e);
            if(!key){
                key = 0;
            }
            if(key>1000000){
                key=1000000;
            }
            row[type] = key;
            row.unit = row.count * row.unitCount + row.small;
            row.sum = (row.unit*row.price).toFixed(2);
            if(row.id>0){
                this.$nextTick(()=>{
                    this.changeSum(row);
                })
            }
        },
        checkTableNumber(e,row){
            let key = parseInt(e*100)/100;
            if(!key||key<0){
                key = 0;
            }
            if(key>1000000){
                key=1000000;
            }
            row.price = key;
            if(row.id>0){
                this.$nextTick(()=>{
                    this.changeSum(row);
                })
            }

        },
        changeSum(row) {
            if(row.id>0){
                var param = {
                    id: row.id,
                    pid: row.pid,
                    spid: row.spid,
                    unit: row.unit,
                    price: row.price,
                    valid: row.valid,
                    remark: row.remark,
                };
                this.$api.ordereditOrderDetail(param).then((res) => {
                    this.$notify({
                        title: "订单产品项修改",
                        message: "修改成功",
                        type: "success",
                        duration: 1000,
                    });
                });
            }
        },
        getAccount() {
            this.$api.companygetCompanyAccount().then((res) => {
                this.acList = res.data.data;
            });
        },
        getProduct(val) {
            let obj = {
                cid:this.orderForm.cid,
            }
            if(val){
                obj.product=val;
            }
            this.listLoading = true;
            this.$api.productlistProduct(obj).then((res) => {
                this.productList = [];
                res.data.data.map((item) => {
                    let tempurl =  item.img.length>0?(this.imgProfit+item.img[0]):"";
                    if (item.specs.length > 0) {
                        item.specs.map((spec) => {
                            if(spec.img.length>0){
                                spec.img = spec.img.map((im) => {
                                    return this.imgProfit + im;
                                });
                            }else{
                                spec.img.push(tempurl);
                            }
                            spec.number = item.number;
                            spec.name = item.name;
                            spec.pid = item.id;
                            spec.spid = spec.id;
                            spec.packing = spec.unit +this.$global.unit+'/'+this.$global.pack;
                            spec.unitCount = spec.unit;
                            this.productList.push(spec);
                        });
                    } else {
                        var spec = {
                            img: [],
                            number: item.number,
                            name: item.name,
                            pid: item.id,
                            packing: item.unit+this.$global.unit+'/'+this.$global.pack,
                            unitCount: item.unit,
                            price: item.price,
                            color: "",
                            size: "",
                        };
                        spec.img.push(tempurl);
                        this.productList.push(spec);
                    }
                });
                this.listLoading = false;
            });
        },
        getList() {
            this.$api.getListOrder({type:this.searchType}).then((res) => {
                this.orderList = res.data.data.list.map((item) => {
                    return item.id;
                });
            });
        },
        getId() {
            let id = this.$route.query.id;
            this.curOrder = id?parseInt(id):0;
            this.searchType = this.$route.query.type;
            this.getInfo();
        },
        getStockDesc(item,type){
            if(type==1){
                let str1 = this.$common.changeNumDesc(item,'stockAmount','stockParts','stockUnit');
                let str2 = this.$common.changeNumDesc(item,'needStockOutAmount','needStockOutParts','needStockOutUnit');
                let str3 = this.$common.changeSendDesc(item.stockUnit-item.needStockOutUnit,item.punit);
                return '库存:'+str1+' 待发:'+str2+' 可用:'+str3;
            }else if(type==2){
                let str1 = this.$common.changeNumDesc(item,'stockAmount','stockParts','stock');
                let str2 = this.$common.changeNumDesc(item,'needStockOutAmount','needStockOutParts','needStockOutUnit');
                let str3 = this.$common.changeSendDesc(item.stock-item.needStockOutUnit,item.unit);
                return '库存:'+str1+' 待发:'+str2+' 可用:'+str3;
            }
            
        },
        getInfo() {
            this.$api.getOrderDetail({ id: this.curOrder }).then((res) => {
                if (res.data.code == 1) {
                    let dt = res.data;
                    this.orderForm = dt.data;
                    this.orderForm.detail.map((item) => {
                        item.image = item.img.map((img) => {
                            return this.imgProfit + img;
                        });
                        if(!item.allNotSendUnit){
                            item.allNotSendUnit = 0;
                        }
                        item.sendedDesc = this.$common.changeSendDesc(item.sended?item.sended:0,item.punit);
                        item.stockDesc = this.getStockDesc(item,1);
                        item.packing = item.punit+this.$global.unit+'/'+this.$global.pack;
                        this.$set(
                            item,
                            "count",
                            parseInt(item.unit / item.punit)
                        );
                        this.$set(item, "small", item.unit % item.punit);
                        this.$set(item, "unitCount", item.punit);
                        var spec = item.color?"-"+item.color+"-"+item.size:""
                        this.$set(item,"name",item.pname+spec);
                        var that = this;
                        this.cols.map((col) => {
                            if (col.edit) {
                                that.$set(item, col.edit, false);
                            }
                        });
                        item.sum = (item.unit*item.price).toFixed(2);
                        return item;
                    });
                    var contact = dt.data.contact;
                    this.$set(this.orderForm,"cname",this.orderForm.customer.name);
                    this.$set(this.orderForm,"cid",this.orderForm.customer.id);
                    this.$set(this.orderForm, "empName", this.orderForm.empName);
                    this.$set(this.orderForm, "emp", this.orderForm.emp);
                    this.$set(this.orderForm, "adddetail", []);
                    this.$set(this.orderForm,"remark",this.orderForm.remark);
                    this.$set(this.orderForm,"accountid",this.orderForm.account.id);
                    this.$set(this.orderForm,"accountname",this.orderForm.account.name);
                    this.$set(this.orderForm, "contact", contact.id);
                    this.invoiceform.invoice = dt.data.invoice;
                    this.invoiceform.taxIdentification =
                        dt.data.taxidentification;
                    this.invoiceform.invoiceaddress = dt.data.invoiceaddress;
                    this.invoiceform.invoicephone = dt.data.invoicephone;
                    this.invoiceform.bankname = dt.data.bankname;
                    this.invoiceform.bankaccountnumber = dt.data.bankaccountnumber;
                    this.$nextTick(() => {
                        this.$refs.paddr.init();
                    });
                    this.$forceUpdate();
                }
                this.getProduct()
            });
        },
        addSameRow(row,index){
            if(index>=0){
                var r = {
                    count: 0,
                    countEdit: false,
                    index: 1,
                    image:[],
                    name: row.name,
                    nameEdit: false,
                    packing: row.packing,
                    pnumber:row.pnumber,
                    pid: row.pid,
                    price: row.price,
                    priceEdit: false,
                    remark: "",
                    remarkEdit: false,
                    small: "",
                    smallEdit: false,
                    spid: row.spid,
                    sum: "0.00",
                    unit: 0,
                    unitCount: row.unitCount,
                    stockDesc:row.stockDesc,
                    valid: 1,
                }
                row.image.forEach(e=>{
                    r.image.push(e);
                })
                this.orderForm.adddetail.push(r);
                this.orderForm.detail.splice(index + 1, 0, r);
                for (let i = 0; i < this.orderForm.adddetail.length; i++) {
                    this.orderForm.adddetail[i].index = i + 1;
                }
            }
        },
        addRow() {
            var row = {
                index: 0,
                image: [],
                name: "",
                pnumber:"",
                packing: "",
                count: "",
                small: "",
                price: "",
                sum: "",
                remark: "",
                valid: 1,
            };
            this.orderForm.adddetail.push(row);
            this.orderForm.detail.unshift(row);
            this.orderForm.detail.map((v) => {
                var that = this;
                this.cols.map((col) => {
                    if (col.edit) {
                        that.$set(v, col.edit, false);
                    }
                });
                return v;
            });
            for (let i = 0; i < this.orderForm.adddetail.length; i++) {
                this.orderForm.adddetail[i].index = i + 1;
            }
        },
        removeRow(index, row) {
            let addindex = this.getDetailIndex('index',row.index);
            this.orderForm.detail.splice(index, 1);
            this.orderForm.adddetail.splice(addindex,1);
            for (let i = 0; i < this.orderForm.adddetail.length; i++) {
                this.orderForm.adddetail[i].index = i + 1;
            }
        },
        editCell(row, column) {
            this.cols.map((col) => {
                if (col.label === column.label) {
                    row[col.edit] = !row[col.edit];
                }
            });
            setTimeout(() => {
                this.$nextTick(() => {
                    if (this.$refs.editCell && this.$refs.editCell.length > 0) {
                        this.$refs.editCell[0].focus();
                    }
                });
            }, 200);
        },
        chooseSpecs($event, row, column) {
            this.cols.map((col) => {
                if (col.label === column.label) {
                    row.pid = $event.pid;
                    row.spid = $event.spid ? $event.spid : 0;
                    row.packing = $event.packing;
                    row.image = $event.img;
                    row.price = $event.price;
                    row.unitCount = $event.unitCount;
                    row.stockDesc = this.getStockDesc($event,2);
                    row.pnumber = $event.number;
                    row[col.prop] =
                        $event.name +
                        ($event.color !== "" ? "_" + $event.color : "") +
                        ($event.size !== "" ? "_" + $event.size : "");
                    row[col.edit] = false;
                }
            });
            if (row.id > 0) {
                this.changeSum(row);
            }
        },
        getData(row, column) {
            setTimeout(() => {
                this.cols.map((col) => {
                    if (col.label === column.label) {
                        row[col.edit] = false;
                    }
                });
            }, 100);
        },
        cancelCell() {},
        cancel(row, column) {
            setTimeout(() => {
                this.cols.map((col) => {
                    if (col.label === column.label) {
                        row[col.edit] = false;
                    }
                });
            }, 100);
        },
        addPro(index, rows) {
            rows.splice(index + 1, 0, {});
        },
        delPro(index, rows) {
            if (rows.length > 1) {
                rows.splice(index, 1);
            }
        },
        changeValid(type, row) {
            var text = "";
            var title = "";
            if (type === 0) {
                text = ["当前订单项将被作废，作废后不可操作", "请确认是否作废"];
                title = "作废订单";
            } else {
                text = [
                    "当前订单项将被恢复，恢复后可进行编辑等操作",
                    "请确认是否恢复",
                ];
                title = "恢复订单";
            }
            const confirmText = text;
            const newData = [];
            const h = this.$createElement;
            for (const i in confirmText) {
                newData.push(h("p", null, confirmText[i]));
            }
            this.$confirm("警告", {
                title: "警告",
                message: h("div", null, newData),
                showCancelButton: true,
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(
                () => {
                    this.$api
                        .ordersetOrderDetailValid({
                            ids: row.id,
                            valid: type,
                        })
                        .then(
                            (res) => {
                                this.$notify({
                                    title: title,
                                    message: "操作成功",
                                    type: "success",
                                    duration: 1000,
                                    onClose: () => {
                                        row.valid = type;
                                    },
                                });
                            },
                            () => {}
                        );
                },
                () => {}
            );
        },
        editSure() {
            const confirmText = [
                "请确保订单中的商品名称填写完成，",
                "若未填写则不会保存！！",
            ];
            if(this.$global.useinstall==1){
                if(!this.orderForm.method){
                    this.$common.error("没有选择货运方式");
                    return;
                }
                if(!this.orderForm.address){
                    this.$common.error("没有填写详细地址");
                    return;
                }
            }
            const newData = [];
            const h = this.$createElement;
            for (const i in confirmText) {
                newData.push(h("p", null, confirmText[i]));
            }
            this.$confirm("警告", {
                title: "警告",
                message: h("div", null, newData),
                showCancelButton: true,
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(
                () => {
                    this.orderForm.addfree = 0;
                    this.orderForm.addpay = 0;
                    let addpath = [];
                    this.orderForm.adddetail.forEach(e=>{
                        if(e.pid>0){
                            let temp = {
                                pid:e.pid,
                                spid:e.spid,
                                unitCount:e.unitCount,
                                price:e.price,
                                unit:e.unit?e.unit:0,
                                valid:e.valid,
                                remark:e.remark,
                            }
                            addpath.push(temp);
                        }
                    })
                    this.orderForm.adddetail = JSON.stringify(addpath);
                    this.$api.ordereditOrder(this.orderForm).then(
                        (res) => {
                            if(res.data.code==1){
                                this.$notify({
                                    title: "修改订单",
                                    message: "修改成功",
                                    type: "success",
                                    duration: 1000,
                                    onClose: () => {
                                        this.$router.replace({
                                            path: "/empty",
                                            query:{id:this.curOrder,type:this.searchType,url:'/orderDetail'},
                                        })
                                    },
                                });
                            }
                        },
                        () => {}
                    );
                },
                () => {}
            );
        },
        productMany(row) {
            this.productListDialog = true;
            this.curRow = row;
		},
        goBack() {
            if(this.$common.hasLimits("order")){
                this.$router.replace({
                    path: "/order",
                });
            }else{
                this.$router.push("/product");
            }
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            const sumCol = [];
            this.cols.map((col) => {
                if (col.sumUp.substring(0, "sum.".length) === "sum.") {
                    sumCol.push(col.label);
                }
            });
            columns.forEach((column, index) => {
                if (index === 0 || index === 1) {
                    return;
                }
                if (sumCol.indexOf(column.label) !== -1) {
                    sums[index] = 0;
                    var prop = "";
                    var fix = 0;
                    data.map((row) => {
                        if(row.valid>0){
                            this.cols.map((col) => {
                                if (column.label === col.label) {
                                    prop = col.prop;
                                    fix = parseInt(
                                        col.sumUp.replaceAll("sum.", "")
                                    );
                                }
                            });
                            sums[index] += Number(row[prop] ? row[prop] : 0);
                        }
                    });
                    sums[index] = sums[index].toFixed(fix);
                } else {
                    this.cols.map((col) => {
                        if (col.label === column.label) {
                            sums[index] = col.sumUp;
                        }
                    });
                }
            });

            return sums;
        },
        accountSelected() {
            this.$nextTick(() => {
                this.$refs.accountList.checkAccount();
            });
        },
        closeAccount(value) {
            this.orderForm.accountname = "";
            this.orderForm.accountid = value[0].id;
            this.orderForm.accountname = value[0].name;
            this.accountListDialog = false;
        },
        invoiceChange() {
            if (this.orderForm.invoicetype === 1) {
                // 普通发票 需：发票抬头，纳税人识别号
                if (
                    !this.orderForm.invoice ||
                    !this.orderForm.taxidentification
                ) {
                    this.$notify({
                        title: "发票信息未完善",
                        message: "请完善信息",
                        type: "warning",
                        duration: 2000,
                        onClose: () => {
                            this.invoiceDialog = true;
                        },
                    });
                }
            } else if (this.orderForm.invoicetype === 2) {
                // 专业发票 需：发票抬头，纳税人识别号，地址，电话，开户银行，开户账号
                if (
                    !this.orderForm.invoice ||
                    !this.orderForm.taxidentification ||
                    !this.orderForm.invoiceaddress ||
                    !this.orderForm.invoicephone ||
                    !this.orderForm.bankname ||
                    !this.orderForm.bankaccountnumber
                ) {
                    this.$notify({
                        title: "发票信息未完善",
                        message: "请完善信息",
                        type: "warning",
                        duration: 2000,
                        onClose: () => {
                            this.invoiceDialog = true;
                        },
                    });
                }
            }
        },
        cancelInvoice() {
            this.invoiceDialog = false;
            if (this.orderForm.invoicetype === 1) {
                if (
                    !this.orderForm.invoice ||
                    !this.orderForm.taxidentification
                ) {
                    this.orderForm.invoicetype = 0;
                }
            } else if (this.orderForm.invoicetype === 2) {
                if (
                    !this.orderForm.invoice ||
                    !this.orderForm.taxidentification ||
                    !this.orderForm.invoiceaddress ||
                    !this.orderForm.invoicephone ||
                    !this.orderForm.bankname ||
                    !this.orderForm.bankaccountnumber
                ) {
                    this.orderForm.invoicetype = 0;
                }
            }
        },
        saveInvoice() {
            this.$refs.invoiceform.validate((valid) => {
                if(valid){
                    if (this.orderForm.invoicetype === 1) {
                    // 普通发票
                    this.$api.customereditCustomerInvoice({
                        id: this.orderForm.cid,
                        invoice: this.invoiceform.invoice,
                        taxIdentification: this.invoiceform.taxIdentification,
                    }).then((res) => {
                        this.invoiceDialog = false;
                        this.$notify({
                            title: "设置发票信息",
                            message: "设置成功",
                            type: "success",
                            duration: 1000,
                            onClose: () => {
                                this.orderForm.invoice = this.invoiceform.invoice;
                                this.orderForm.taxidentification = this.invoiceform.taxIdentification;
                            },
                        });
                    });
                    } else if (this.orderForm.invoicetype === 2) {
                    // 专用发票
                    this.$api.customereditCustomerInvoice({
                        id: this.orderForm.cid,
                        invoice: this.invoiceform.invoice,
                        taxIdentification: this.invoiceform.taxIdentification,
                        invoiceaddress: this.invoiceform.invoiceaddress,
                        invoicephone: this.invoiceform.invoicephone,
                        bankname: this.invoiceform.bankname,
                        bankaccountnumber: this.invoiceform.bankaccountnumber,
                    }).then((res) => {
                        this.invoiceDialog = false;
                        this.$notify({
                            title: "设置发票信息",
                            message: "设置成功",
                            type: "success",
                            duration: 1000,
                            onClose: () => {
                                this.orderForm.invoice = this.invoiceform.invoice;
                                this.orderForm.taxidentification = this.invoiceform.taxIdentification;
                                this.orderForm.invoiceaddress = this.invoiceform.invoiceaddress;
                                this.orderForm.invoicephone = this.invoiceform.invoicephone;
                                this.orderForm.bankname = this.invoiceform.bankname;
                                this.orderForm.bankaccountnumber = this.invoiceform.bankaccountnumber;
                            },
                        });
                    });
                    }
                }
            });  
        },
        setAccount(id) {
            for(let i=0;i<this.acList.length;i++){
                if(this.acList[i].id==id){
                    this.orderForm.accountid = this.acList[i].id;
                    this.orderForm.accountname = this.acList[i].name;
                    break;
                }
            } 
        },
        checkThis(row) {
            this.$nextTick(() => {
                this.$refs.multipleTable.toggleRowSelection(row);
            });
        },
    },
    computed:{
        checkSteps:function(){
            if(this.orderForm.state==0){
                return 1;
            }else if(this.orderForm.state==1){
                return 2;
            }else if(this.orderForm.state==3){
                return 3;
            }else if(this.orderForm.state==4){
                return 4;
            }else{
                return 0;
            }
        }
    }
};
</script>

<style lang="scss" scoped>

.clearfix {
    .left {
        display: flex;
        align-items: center;
        .iconfont {
            color: #333940;
            font-size: 18px;	
        }
    }
}


.productList {
    position: absolute;
    right: 13px;
    height: 34px;
    line-height: 34px;
    background: #fff;
    top: 11px;
    width: 24px;
    text-align: center;
}

.customerList {
    position: relative;
    right: 25px;
    background: #fff;
    cursor: pointer;
}
.number_box{
    position: absolute;
    top: 18px;
    right: 30px;
    font-size: 18px;  
}
.edit-input {
    padding-right: 100px;
}

.cancel-btn {
    position: absolute;
    right: 15px;
    top: 10px;
}

.footer {
    margin-top: 20px;
    .account {
        position: relative;
        right: 25px;
        background: #fff;
        cursor: pointer;
    }
}
</style>
